<template>
    <div class="VehicleForm">
        <DashboardEditSection title="Information">
            <FormSelect
                v-model="$v.type.$model"
                label="Type"
                :errors="$v.type.$error ? [
                    !$v.type.required && 'Type name is required',
                ] : null"
                :disabled="isEditMode"
            >
                <option value="truck">Truck</option>
                <option value="trailer">Trailer</option>
            </FormSelect>
            <FormInput
                v-model="$v.name.$model"
                label="Name"
                :errors="$v.name.$error ? [
                    !$v.name.required && 'Vehicle name is required',
                ] : null"
            />
            <Row>
                <Column :md="4">
                    <FormInput v-model="make" label="Make"/>
                </Column>
                <Column :md="4">
                    <FormInput v-model="model" label="Model"/>
                </Column>
                <Column :md="4">
                    <FormNumber v-model="year" label="Year" :min="0" :max="9999"/>
                </Column>
            </Row>
            <FormInput v-model="licensePlate" label="License Plate"/>
            <FormInput v-model="vin" label="VIN"/>
            <FormTonsInput v-model="tonsCapacity" label="Ton Capacity"/>
        </DashboardEditSection>
    </div>
</template>

<script>
import DashboardEditSection from '@/components/DashboardEditSection';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'VehicleForm',

    components: { DashboardEditSection },

    props: {
        isEditMode: { type: Boolean, default: false },
    },

    syncProps: [
        'name',
        'make',
        'model',
        'year',
        'licensePlate',
        'vin',
        'type',
        'tonsCapacity',
    ],

    validations: {
        name: {
            required,
        },
        type: {
            required,
        },
    },

    methods: {
        validate() {
            this.$v.$touch();
            return !this.$v.$invalid;
        },
    },
}
</script>
